export default __webpack_public_path__ + "static/media/Icon-hr.2302b542.svg";